/**
 * QueuePage
 *
 * Approval queue page showing investments in a Kanban-style board
 */

import React from 'react';

import { QueueView } from './components/QueueView';

export function QueuePage() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">Approval Queue</h1>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            Track investment requests through the approval workflow
          </p>
        </div>

        {/* Queue View */}
        <QueueView />
      </div>
    </div>
  );
}

export default QueuePage;
